import { all } from "redux-saga/effects";
import { keyEventsReducer } from "./keyEventsSlice";
import { videoInterviewsReducer } from "./vidoesInterviewsSlice";

export const rootReducer = {
  keyEvents: keyEventsReducer,
  videoInterviews:videoInterviewsReducer
};

export function* rootSaga() {
  yield all([]);
}
